// An export returns a blob, so the api has no response body to put a message in. It sends one in the
// X-Export-Message header instead, which the api's CORS policy exposes to the browser. Report modals
// use this to tell the user something about the file they just downloaded - that it came back empty,
// for example - instead of the usual success toast.
export function getExportMessage(response) {
    return response?.headers?.['x-export-message'] || null;
}
